import _jsx from "@babel/runtime/helpers/jsx";
var _Glyphicon;
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import { Button, Glyphicon } from 'reaxl';
import { formatNumber } from '@atc/string-fns';

/**
 *  FilteredResultsHeader is a custom component that is designed to
 *  allow users to scroll and still have a quick way to view filters
 *  A callback method is exposed for button click.
 *
 */

function FilteredResultsHeader(_ref) {
  let {
    label = '',
    resultCount = 0,
    onFilterClick = () => {},
    inverted = true,
    filterCount = 0,
    ...rest
  } = _ref;
  const textClass = clsx('text-container text-size-200', {
    'text-inverse': inverted
  });
  const showFilterCount = filterCount && filterCount > 0 ? ` (${filterCount})` : '';
  return /*#__PURE__*/React.createElement("header", Object.assign({}, rest, {
    "data-cmp": "FilteredResultsHeader"
  }), /*#__PURE__*/_jsx("div", {
    className: "display-flex align-items-center padding-3"
  }, void 0, /*#__PURE__*/_jsx(Button, {
    className: "margin-right-3",
    bsStyle: "primary",
    onClick: onFilterClick
  }, void 0, _Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
    className: "margin-right-1",
    glyph: "filter"
  })), "Filter", showFilterCount), /*#__PURE__*/_jsx("div", {
    className: textClass
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "text-bold"
  }, void 0, label), /*#__PURE__*/_jsx("div", {}, void 0, `${formatNumber({
    value: resultCount
  })} ${resultCount === 1 ? 'Result' : 'Results'}`))));
}
export default FilteredResultsHeader;